import { NgModule } from "@angular/core";

import { PipeServicesModule } from "@lantern/app/core/utils/pipe-services";

import { DecimalPercentagePipe } from "./decimal-percentage.pipe";
import { FileSizePipe } from "./file-size.pipe";
import { ShortNumberPipe } from "./short-number.pipe";
import { TruncationPipe } from "./truncation.pipe";

@NgModule({
  imports: [PipeServicesModule],
  declarations: [
    DecimalPercentagePipe,
    FileSizePipe,
    ShortNumberPipe,
    TruncationPipe
  ],
  exports: [
    DecimalPercentagePipe,
    FileSizePipe,
    ShortNumberPipe,
    TruncationPipe
  ]
})
export class PipesModule {}
